module.exports = __webpack_public_path__ + "static/img/64.66809d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/64.png
// module id = 5s73
// module chunks = 0